// 1. 同时导入 dynamicService 和 staticService
import { dynamicService, staticService } from '../index';
// 新训练中心
// 重新抽取和分析文件的知识点
export function reextractKnowledgePoint(file_id) {
    const path = `/api/v1/training/file/${file_id}/reextract`;
    return dynamicService.post(path);
}
// 训练数据列表
export function trainingList(params) {
    const path = `/api/v1/training/list`;
    return dynamicService.get(path, { params });
}
// 手动添加训练数据
export function createTrainingData(data) {
    const path = `/api/v1/training/create`;
    return dynamicService.post(path, data);
}
// 编辑训练数据
export function updateTrainingData(td_id, data) {
    const path = `/api/v1/training/${td_id}`;
    return dynamicService.put(path, data);
}
// 删除训练数据(逻辑删除)
export function deleteTrainingData(td_id) {
    const path = `/api/v1/training/${td_id}`;
    return dynamicService.delete(path);
}
// 知识领域列表
export function knowledgeDomainsList(params) {
    const path = `/api/v1/training/knowledge-domains`;
    return dynamicService.get(path, { params });
}
// 创建知识领域
export function createKnowledgeDomain(data) {
    const path = `/api/v1/training/knowledge-domains`;
    return dynamicService.post(path, data);
}
// 更新知识领域
export function updateKnowledgeDomain(domain_id, data) {
    const path = `/api/v1/training/knowledge-domains/${domain_id}`;
    return dynamicService.put(path, data);
}
// 删除知识领域
export function deleteKnowledgeDomain(domain_id, params) {
    const path = `/api/v1/training/knowledge-domains/${domain_id}`;
    return dynamicService.delete(path, { data: params });
}
// 批量同步训练数据领域
export function syncKnowledgeDomains(data) {
    const path = `/api/v1/training/knowledge-domains/sync`;
    return dynamicService.post(path, data);
}
// 采用知识点
export function adoptKnowledgePoint(data) {
    const path = `/api/v1/training/adopt`;
    return dynamicService.post(path, data);
}
// 不采用知识点
export function skipKnowledgePoint(data) {
    const path = `/api/v1/training/skip`;
    return dynamicService.post(path, data);
}
// 修改训练数据
export function modifyKnowledgePoint(data) {
    const path = `/api/v1/training/modify`;
    return dynamicService.post(path, data);
}
// 融合知识点
export function mergeKnowledgePoint(data) {
    const path = `/api/v1/training/merge`;
    return dynamicService.post(path, data);
}
// AI 自动融合知识点
export function aiMergeKnowledgePoint(data) {
    const path = `/api/v1/training/ai_merge`;
    return dynamicService.post(path, data);
}
// 文件知识点融合
export function mergeFilePoints(data) {
    const path = `/api/v1/training/file_points/merge`;
    return dynamicService.post(path, data);
}
// 文件知识点AI自动融合
export function aiMergeFilePoints(data) {
    const path = `/api/v1/training/file_points/ai-merge`;
    return dynamicService.post(path, data);
}
// AI对话(带训练数据参考)
export function trainingChat(data) {
    const path = `/api/v1/training/chat`;
    return dynamicService.post(path, data);
}
// 合并重复训练数据
export function mergeDuplicates(data) {
    const path = `/api/v1/training/merge-duplicates`;
    return dynamicService.post(path, data);
}
// 知识库知识点列表
export function knowledgePointsList(params) {
    const path = `/api/v1/training/knowledge-points`;
    return dynamicService.get(path, { params });
}
// 删除知识库知识点
export function deleteKnowledgePoint(file_point_id, params) {
    const path = `/api/v1/training/file_points/${file_point_id}`;
    return dynamicService.delete(path, { params });
}
// 采用知识点(按知识点ID)
export function adoptKnowledgePointById(data) {
    const path = `/api/v1/training/file_points/adopt`;
    return dynamicService.post(path, data);
}
// 不采用知识点(按知识点ID)
export function skipKnowledgePointById(data) {
    const path = `/api/v1/training/file_points/skip`;
    return dynamicService.post(path, data);
}
// 修改知识点(按知识点ID)
export function modifyKnowledgePointById(data) {
    const path = `/api/v1/training/file_points/modify`;
    return dynamicService.post(path, data);
}
// 提交反馈
export function submitFeedback(data) {
    const path = `/api/v1/training/feedback`;
    return dynamicService.post(path, data);
}
// 概览统计
export function statisticsOverview(params) {
    const path = `/api/v1/training/statistics/overview`;
    return dynamicService.get(path, { params });
}
// 学习曲线
export function statisticsLearningCurve(params) {
    const path = `/api/v1/training/statistics/learning-curve`;
    return dynamicService.get(path, { params });
}
// 知识覆盖
export function statisticsCoverage(params) {
    const path = `/api/v1/training/statistics/coverage`;
    return dynamicService.get(path, { params });
}
// 数据质量分析
export function statisticsQuality(params) {
    const path = `/api/v1/training/statistics/quality`;
    return dynamicService.get(path, { params });
}
// 使用历史
export function statisticsUsageHistory(params) {
    const path = `/api/v1/training/statistics/usage-history`;
    return dynamicService.get(path, { params });
}
// 优化建议
export function statisticsSuggest(params) {
    const path = `/api/v1/training/statistics/suggestions`;
    return dynamicService.get(path, { params });
}
// 以下存量废弃模型训练(对旧 config.js 的依赖已被移除) /////////////////
// --- Llama Dataset/Train APIs (使用动态域名) ---
export function datasetlist(params) {
    const path = `/api/v1/llama/dataset/list`;
    return dynamicService.get(path, { params });
}
export function getmodels() {
    const path = `/api/v1/llama/llama/model`;
    return dynamicService.get(path);
}
export function delete_dataset(dataset_id, params) {
    const path = `/api/v1/llama/dataset/${dataset_id}`;
    return dynamicService.delete(path, { params });
}
export function trainlist(params) {
    const path = `/api/v1/llama/train/list`;
    return dynamicService.get(path, { params });
}
export function exec_list(params) {
    const path = `/api/v1/llama/train/exec_list`;
    return dynamicService.get(path, { params });
}
export function deploy_list(params) {
    const path = `/api/v1/llama/train/deploy_list`;
    return dynamicService.get(path, { params });
}
// --- User ID API (使用固定的 ModelManagementApi04 域名) ---
// export function getUserId(id, params) { // 原有获取短id address.xinfushenghuo.cn
//     // 2. 使用模板字符串拼接路径，注意这里不需要域名了
//     const path = `/auction/init/getUserId?id=${id}`;
//     // 3. 使用为固定域名创建的 staticService
//     return staticService.post(path, params);
// }
export function getUserId(id, params) {
    const path = `/api/v1/common/get_user_id/${id}`;
    return dynamicService.get(path, params);
}
export function saveToken(data) {
    const path = `/api/v1/common/save_token`;
    return dynamicService.post(path, data);
}
export function getLoginInfo(id, params) {
    // 2. 使用模板字符串拼接路径，注意这里不需要域名了
    const path = `/api/v1/common/oa_userid?encrypted_param=${id}`;
    // 3. 使用为固定域名创建的 staticService
    return dynamicService.get(path, params);
}
export function getPCuserInfo(token,user_id) {
    // 2. 使用模板字符串拼接路径，注意这里不需要域名了
    const path = `/api/v1/common/xf_get_user_info?user_id=${user_id}&token=${token}`;
    // 3. 使用为固定域名创建的 staticService
    return dynamicService.get(path);
}
export function getUserToken(user_id) {
    // 获取用户token的接口
    const path = `/user/token?user_id=${user_id}`;
    return dynamicService.get(path);
}
//发布数据集
export function publish(dataset_id,params) {
    const path = `/api/v1/llama/dataset/${dataset_id}/publish`;
    return dynamicService.put(path, { params });
}
// 取消
export function unpublish(dataset_id,params) {
    const path = `/api/v1/llama/dataset/${dataset_id}/unpublish`;
    return dynamicService.put(path, { params });
}
// 导出
export function downloadSJJ(dataset_id,params) {
    const path = `/api/v1/llama/dataset/${dataset_id}/download`;
    return dynamicService.get(path, { params });
}
//创建模型训练
export function llamaTrain(params) {
    const path = `/api/v1/llama/train`;
    return dynamicService.post(path,  params );
}
export function runTrain(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/run`;
    return dynamicService.put(path,  params );
}
export function trainunpublish(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/unpublish`;
    return dynamicService.put(path,  params );
}
export function deletetrain(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}`;
    return dynamicService.delete(path,  params );
}
export function trainpause(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/pause`;
    return dynamicService.put(path,  params );
}
export function traindeploy(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/deploy`;
    return dynamicService.put(path,  params );
}
export function trainpublish(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/publish`;
    return dynamicService.put(path,  params );
}

export function datasetpreview(dataset_id,params) {
    const path = `/api/v1/llama/dataset/${dataset_id}/preview`;
    return dynamicService.get(path, { params });
}
export function trainlogs(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/logs`;
    return dynamicService.get(path,  params );
}
export function traindeploy_logs(train_id,params) {
    const path = `/api/v1/llama/train/${train_id}/deploy_logs`;
    return dynamicService.get(path,  params );
}
export function llamaupload(train_id,params) {
    const path = `/api/v1/llama/upload`;
    return dynamicService.post(path,  params );
}
export function llamadataset(params) {
    const path = `/api/v1/llama/dataset`;
    return dynamicService.post(path,   params  );
}
export function trainuninstall(train_id, params) {
    const path = `/api/v1/llama/train/${train_id}/uninstall`;
    return dynamicService.delete(path,  params );
}